export default __webpack_public_path__ + "static/banner-simvent-1-303b435d174ff16deb19fb228906e861.jpeg";